module.exports = __webpack_public_path__ + "static/media/skrivehastighetIntroExtended.0c786789.mp3";